<template>
  <div class="nrh-m01-view">
    <statusBar v-bind="status" style="margin-bottom: 20px" />
    <v-chart
      :options="relativeValOp"
      :autoresize="true"
      style="border: 1px solid rgb(96, 118, 173); height: 90% !important"
    />
  </div>
</template>

<script>
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/echartOption/common';
import { formatTimestamp } from '@/utils/utils';
import { isEmpty } from '@/utils/is';

import statusBar from '../wireless-box/components/status-bar.vue';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';

export default {
  name: 'NRH-M01',
  mixins: [singleDeviceMixin],

  sockets: {
    '/socket/detail'(res) {
      this.update(res);
    }
  },
  components: {
    statusBar
  },
  data() {
    return {
      maxLen: 30,
      status: {
        alarmStatus: 0,
        runState: 0,
        humidity: 0,
        temp: 0,
        radonConcentrationError: 0
      },
      relativeValOp: lineAreaStyle({
        color: ['#833BBB', '#3368F2'],
        legend: {
          top: 'auto',
          right: '5%',
          icon: 'circle',
          orient: 'vertical',
          textStyle: {
            color: '#fff'
          }
        },
        title: { text: '氡气/Rn', left: 'center' },
        yAxis: { type: 'value' },
        xAxis: {
          type: 'category',
          data: []
        },
        series: [
          {
            name: '氡气浓度(Bq/m³)',
            type: 'line',
            symbol: 'emptyCircle',
            areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') },
            smooth: true,
            data: []
          }
        ]
      })
    };
  },
  methods: {
    update(res) {
      if (res.sn === this.sn) {
        this.setData(res);
      }
    },
    setData(res) {
      let { nrhM01Mod, weatherMod } = res.mods;

      this.status.alarmStatus = nrhM01Mod.state;
      this.status.runState = nrhM01Mod.runstate;
      this.status.radonConcentrationError = nrhM01Mod.radonConcentrationError;
      if (!isEmpty(weatherMod)) {
        this.status.humidity = weatherMod.humidity;
        this.status.temp = weatherMod.temp;
      }

      this.relativeValOp.xAxis.data.push(formatTimestamp(res.beginTime));
      this.relativeValOp.series[0].data.push(nrhM01Mod.radonConcentration);

      if (this.relativeValOp.xAxis.data.length > this.maxLen) {
        this.relativeValOp.xAxis.data.shift();
        this.relativeValOp.series[0].data.shift();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.nrh-m01-view {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
}
</style>
